export enum FieldType {
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  YES_NO = 'YES_NO',
  SELECTION = 'SELECTION',
  LIST = 'LIST',
  TABLE = 'TABLE',
  DATE = 'DATE',
  TIME = 'TIME',
  PERIOD = 'PERIOD',
  PERCENT = 'PERCENT',
  ROOM = 'ROOM',
  ORG_UNIT = 'ORG_UNIT',
  COST_CENTRE = 'COST_CENTRE',
  EMPLOYEE_TYPE = 'EMPLOYEE_TYPE',
  EMPLOYEE_NUMBER = 'EMPLOYEE_NUMBER',
  CLIENT = 'CLIENT',
  TELEPHONE = 'TELEPHONE',
  MOBILE = 'MOBILE',
  FAX = 'FAX',
  EMAIL = 'EMAIL',
  HEADER = 'HEADER',
  DESCRIPTION = 'DESCRIPTION',
  FILE = 'FILE',
  BLANK_SPACE = 'BLANK_SPACE',
  SELECTION_PLUS = 'SELECTION_PLUS',
  SEPARATOR_LINE = 'SEPARATOR_LINE',
  FILESERVICE = 'FILESERVICE',
  APPLICATION = 'APPLICATION',
  PROJECT = 'PROJECT',
  PERSON = 'PERSON',
  PERSON_LIST = 'PERSON_LIST',
  CAD = 'CAD',
  CONFLUENCE = 'CONFLUENCE',
  GENERAL = 'GENERAL',
  IT = 'IT',
  JIRA = 'JIRA',
  ACCOUNT = 'ACCOUNT',
  PERIODS = 'PERIODS',
  BIMEDIAL = 'BIMEDIAL',
  MCLOUD = 'MCLOUD',
  MUSIC_MASTER = 'MUSIC_MASTER',
  MOBILE_WORK_AGREEMENT = 'MOBILE_WORK_AGREEMENT',
  DISABILITY_STATUS = 'DISABILITY_STATUS',
  PRODUCTION_UNIT = 'PRODUCTION_UNIT',
  SELECTION_TABLE = 'SELECTION_TABLE',
  RABBIT = 'RABBIT'
}
